export default "icons-star"